import DataStore, { Query } from 'src/core/stores/data-store';
import { LicenseLogCsvReportRequest, LicenseLogSummary } from 'src/stores/licensing-logs-store';
import FormStoreMock from './base/form-store';
import { LicenseLogSummaryMockData } from '../data-sources/license-log-summary';

export class LicenseLogSummaryStoreMock extends DataStore<LicenseLogSummary> {
  constructor(baseUrl: string) {
    super(`${baseUrl}/api/licenses/get-logs`, []);
  }
  public async load(query: Partial<Query>): Promise<any> {
    this._state.set({
      isBusy: false,
      items: LicenseLogSummaryMockData,
      count: LicenseLogSummaryMockData.length,
    });
  }
}

export class LicenseLogReportItemStoreMock extends FormStoreMock<any, any> {
  public async get(item: LicenseLogCsvReportRequest) {
    return true;
  }
}
